module.exports = __webpack_public_path__ + "static/anh-2ab7efc85b890e15aade907ea6f86772.jpg";